var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('shop-table',{attrs:{"products":_vm.packages,"isPackage":true}}),_c('router-view',{attrs:{"name":"details"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }